import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e51bddf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between" }
const _hoisted_2 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-3 fw-semobold mb-8" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = {
  key: 1,
  class: "card mb-5 mb-xl-8"
}
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "card-title" }
const _hoisted_9 = { class: "card-toolbar gap-4" }
const _hoisted_10 = { class: "d-flex align-items-center" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold me-3" }, "Callback Time ( Min. )", -1))
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = {
  class: "table align-middle table-row-dashed fs-6",
  id: "table_accounts_requests"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 0,
  colspan: "13",
  class: "fw-semibold"
}
const _hoisted_17 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_18 = { class: "d-flex align-items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold w-150px" }, "High Dollar Threshold", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold ms-11 me-3" }, "Updated By:", -1))
const _hoisted_21 = {
  key: 1,
  colspan: "9",
  class: "fw-semibold mt-4"
}
const _hoisted_22 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 2 }
const _hoisted_26 = { key: 3 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = { style: {"width":"120px"} }
const _hoisted_31 = { key: 3 }
const _hoisted_32 = { class: "fw-bold text-warning-emphasis" }
const _hoisted_33 = { key: 0 }

import { ref, onMounted, watch } from "vue";
import PaymentService from "../services/PaymentService";
import paymentServiceDetail from "../components/PaymentServiceDetail.vue";
import paymentServiceCreate from "../components/PaymentServiceCreate.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";
import { ElNotification } from "element-plus";
import notification from "@/core/plugins/notification";
import PaymentAutoOpenConfig from "../components/PaymentAutoOpenConfig.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentServiceIndex',
  setup(__props) {

const store = useStore();
const tab = ref("Deposit");
const { t } = useI18n();
const services = ref(Array<any>());
const tempServices = ref(Array<any>());
const isLoading = ref(true);
const isSubmitting = ref(false);
const paymentDetailRef = ref<any>(null);
const paymentCreateRef = ref<any>(null);
const updateHistory = ref(Array<any>());
const sortedServices = {};
const platform = ref(Array<any>());
const hideActive = ref(true);
const highDollarInfo = ref({} as any);
const callbackTime = ref(null);
const criteria = ref({
  page: 1,
  size: 100,
  sortField: "Sequence",
  sortFlag: false,
});

const updateCallbackTime = async () => {
  isSubmitting.value = true;
  try {
    await PaymentService.updateCallbackTime({
      CallbackExpiredTimeInMinutes: callbackTime.value,
    });
    notification.success();
  } catch (error) {
    console.log(error);
    notification.danger();
  }
  isSubmitting.value = false;
};

const updateHighDollarConfigValue = async () => {
  isSubmitting.value = true;
  try {
    await PaymentService.updateHighDollarConfig(0, {
      value: highDollarInfo.value.value,
    });
    MsgPrompt.success("Save successfully");
  } catch (error) {
    console.log(error);
  }
  isSubmitting.value = false;
};

const getServices = async () => {
  isLoading.value = true;
  try {
    const [callBack, highDollar, auditBody, responseBody] = await Promise.all([
      PaymentService.getCallBackInfo().then((res) => {
        if (res) {
          callbackTime.value = res.value["callbackExpiredTimeInMinutes"];
        }
      }),
      PaymentService.getHighDollarLatestInfo().then((res) => {
        if (res) {
          highDollarInfo.value = {
            value: JSON.parse(res?.values.currentValues.Value).Value,
            staff: res?.user.displayName,
          };
        }
      }),
      PaymentService.getPaymentServicesUpdateBy({
        type: 23,
      }),
      tab.value == "Deposit"
        ? PaymentService.getDepositPaymentMethodsV2(criteria.value)
        : PaymentService.getWithdrawPaymentMethodsV2(criteria.value),
    ]);

    services.value = responseBody;
    services.value = services.value.map((item) => {
      return {
        ...item,
        isUpdated: false,
        group: item.group?.trim(),
        status: item.status === 10,
        updatedBy: auditBody.data.find(
          (x) =>
            x.rowId === item.id &&
            Object.keys(x.values.originalValues).length > 0
        ),
      };
    });

    const updatedBy = services.value
      .map((item) => item.updatedBy)
      .filter((updated) => updated !== undefined);

    platform.value = [
      ...new Set(services.value.map((service) => service.platform)),
    ];

    services.value = services.value.reduce((index, item) => {
      var group = item.group == "" ? "System Manual" : item.group;

      if (index[group]) {
        index[group].push(item);
      } else {
        index[group] = [item];
      }
      return index;
    }, {});

    if (services.value["Union Pay"]) {
      sortedServices["Union Pay"] = services.value["Union Pay"];
      Object.keys(services.value)
        .sort()
        .forEach((category) => {
          if (category !== "Union Pay") {
            sortedServices[category] = services.value[category];
          }
        });

      services.value = sortedServices;
    }

    updateHistory.value = updatedBy.reduce((index, item) => {
      index[item.rowId] = {
        createdOn: formatDateTime(item.createdOn),
        userName: item.user.firstName + " " + item.user.lastName,
        previous: {
          [t("fields.activate")]: boolValue(item.values.originalValues?.status),

          [t("fields.initMinAmount")]: item.values.originalValues?.InitialValue,
          [t("fields.minAmount")]: item.values.originalValues?.MinValue,
          [t("fields.maxAmount")]: item.values.originalValues?.MaxValue,
          [t("fields.category")]: item.values.originalValues?.group?.trim(),
        },
        current: {
          [t("fields.activate")]: boolValue(item.values.currentValues?.status),

          [t("fields.initMinAmount")]: item.values.currentValues?.InitialValue,
          [t("fields.minAmount")]: item.values.currentValues?.MinValue,
          [t("fields.maxAmount")]: item.values.currentValues?.MaxValue,
          [t("fields.category")]: item.values.currentValues?.group?.trim(),
        },
      };

      return index;
    }, {});
    tempServices.value = Object.assign({}, services.value);
    hideInactive();
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const changeTab = (_tab: any) => {
  tab.value = _tab;
  if (_tab === "Configuration") {
    return;
  }
  getServices();
};

onMounted(async () => {
  getServices();
});

watch(hideActive, (value) => {
  if (value) {
    services.value = Object.keys(services.value)
      .filter((category) => {
        return services.value[category].some((item) => {
          return item.status;
        });
      })
      .reduce((index, category) => {
        index[category] = services.value[category].filter((item) => {
          return item.status;
        });
        return index;
      }, {});
  } else {
    services.value = tempServices.value;
  }
});

const hideInactive = () => {
  if (hideActive.value) {
    services.value = Object.keys(services.value)
      .filter((category) => {
        return services.value[category].some((item) => {
          return item.status;
        });
      })
      .reduce((index, category) => {
        index[category] = services.value[category].filter((item) => {
          return item.status;
        });
        return index;
      }, {});
  } else {
    services.value = tempServices.value;
  }
};

const showPaymentDetail = (item: any, category: any) => {
  paymentDetailRef.value?.show(item, category);
};

const showPaymentCreate = (category: any) => {
  paymentCreateRef.value?.show(category, platform.value, tab.value);
};

const singleSubmit = async (item: any) => {
  isSubmitting.value = true;

  const payload = ref({} as any);
  payload.value = JSON.parse(JSON.stringify(item));

  if (payload.value.status) {
    payload.value.status = 10;
  } else {
    payload.value.status = 0;
  }

  try {
    await updateStatus(item.id, payload.value)
      .then(() => {
        ElNotification({
          title: payload.value.name,
          message: " updated successfully",
          type: "success",
        });
      })
      .catch(() => {
        ElNotification({
          title: payload.value.name,
          message: "Updated failed",
          type: "error",
        });
      });
  } catch (error) {
    console.log(error);
  }
  isSubmitting.value = false;

  // getServices();
};

const resetCache = async () => {
  isLoading.value = true;
  try {
    await PaymentService.PaymentMethodsResetCache();
    MsgPrompt.success(t("tip.submitSuccess")).then(() => {
      getServices();
    });
  } catch (error) {
    MsgPrompt.error(t("tip.submitError"));
  }
  isLoading.value = false;
};

const onEventSubmitted = () => {
  getServices();
};

const updateStatus = async (id: number, item: any) => {
  try {
    await PaymentService.putPaymentMethodByIdV2(id, {
      ...item,
    });
  } catch (error) {
    console.log(error);
  }
};

const boolValue = (value: number) => {
  if (value == 1) return "On";
  else if (value == 0) return "Off";
};

const formatDateTime = (isoString) => {
  let dateObj = new Date(isoString);
  let formattedDate = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(dateObj);
  let formattedTime = new Intl.DateTimeFormat("en-US", {
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  }).format(dateObj);
  return `${formattedDate} ${formattedTime}`;
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_el_popover = _resolveComponent("el-popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createElementVNode("a", {
            class: _normalizeClass([
            'nav-link text-active-primary pb-1',
            { active: tab.value == 'Deposit' },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (changeTab('Deposit')))
          }, "Deposit", 2)
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("a", {
            class: _normalizeClass([
            'nav-link text-active-primary pb-1',
            { active: tab.value == 'Withdrawal' },
            { 'disabled opacity-50 pe-none': isLoading.value },
          ]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (changeTab('Withdrawal')))
          }, "Withdraw", 2)
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("a", {
            class: _normalizeClass([
            'nav-link text-active-primary pb-1',
            { active: tab.value == 'Configuration' },
            {
              'disabled opacity-50 pe-none':
                isLoading.value && tab.value !== 'Configuration',
            },
          ]),
            href: "#",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeTab('Configuration')))
          }, "Configuration", 2)
        ])
      ]),
      (tab.value !== 'Configuration')
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "warning",
            onClick: resetCache
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.resetCache")), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (tab.value === 'Configuration')
      ? (_openBlock(), _createBlock(PaymentAutoOpenConfig, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_switch, {
                modelValue: hideActive.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((hideActive).value = $event)),
                "active-text": "Hide Inactive",
                "inactive-text": "Show All",
                size: "large",
                style: {"font-size":"18px"},
                disabled: isSubmitting.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(_component_el_input, {
                  class: "w-100px",
                  modelValue: callbackTime.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((callbackTime).value = $event)),
                  placeholder: "",
                  type: "number",
                  disabled: isSubmitting.value
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode(_component_el_button, {
                  class: "ms-3",
                  type: "success",
                  onClick: updateCallbackTime,
                  disabled: isSubmitting.value,
                  plain: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Update ")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createVNode(_component_el_button, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showPaymentCreate(sortedServices))),
                type: "primary",
                disabled: isSubmitting.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Add Payment Service ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("table", _hoisted_13, [
              (isLoading.value)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                    _createVNode(_component_LoadingRing)
                  ]))
                : (!isLoading.value && services.value.length === 0)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                      _createVNode(_component_NoDataBox)
                    ]))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(services.value, (value, i) => {
                      return (_openBlock(), _createElementBlock("tbody", {
                        key: i,
                        class: "fw-semibold text-gray-900 tbody"
                      }, [
                        _createElementVNode("tr", null, [
                          (i == 'Union Pay')
                            ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createElementVNode("h4", null, _toDisplayString(i), 1),
                                  _createElementVNode("div", _hoisted_18, [
                                    _hoisted_19,
                                    _createVNode(_component_el_input, {
                                      class: "w-150px ms-3",
                                      type: "number",
                                      modelValue: highDollarInfo.value.value,
                                      "onUpdate:modelValue": ($event: any) => ((highDollarInfo.value.value) = $event),
                                      disabled: isSubmitting.value
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]),
                                    _createVNode(_component_el_button, {
                                      class: "ms-3",
                                      type: "success",
                                      onClick: updateHighDollarConfigValue,
                                      disabled: isSubmitting.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Update ")
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"]),
                                    _hoisted_20,
                                    _createElementVNode("div", null, _toDisplayString(highDollarInfo.value.staff), 1)
                                  ])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_21, [
                                _createElementVNode("h4", null, _toDisplayString(i), 1)
                              ]))
                        ]),
                        _createElementVNode("tr", _hoisted_22, [
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.name")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.autoDeposit")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.activate")), 1),
                          (i == 'Union Pay')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_23, _toDisplayString(_ctx.$t("fields.highDollar")), 1))
                            : (_openBlock(), _createElementBlock("th", _hoisted_24)),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.currency")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.initMinAmount")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.minAmount")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.maxAmount")), 1),
                          (i == 'Union Pay')
                            ? (_openBlock(), _createElementBlock("th", _hoisted_25, _toDisplayString(_ctx.$t("fields.percentage")), 1))
                            : (_openBlock(), _createElementBlock("th", _hoisted_26)),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedBy")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1),
                          _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.detail")), 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            _createElementVNode("td", null, _toDisplayString(item.name) + " " + _toDisplayString(item.id), 1),
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_switch, {
                                modelValue: item.isAutoDepositEnabled,
                                "onUpdate:modelValue": ($event: any) => ((item.isAutoDepositEnabled) = $event),
                                onChange: ($event: any) => (singleSubmit(item)),
                                "active-value": 1,
                                "inactive-value": 0,
                                disabled: isSubmitting.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_switch, {
                                modelValue: item.status,
                                "onUpdate:modelValue": ($event: any) => ((item.status) = $event),
                                onChange: ($event: any) => (singleSubmit(item)),
                                disabled: isSubmitting.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                            ]),
                            (i == 'Union Pay')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_27, [
                                  _createVNode(_component_el_switch, {
                                    modelValue: item.isHighDollarEnabled,
                                    "onUpdate:modelValue": ($event: any) => ((item.isHighDollarEnabled) = $event),
                                    onChange: ($event: any) => (singleSubmit(item)),
                                    "active-value": 1,
                                    "inactive-value": 0
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_28)),
                            _createElementVNode("td", null, _toDisplayString(_unref(t)(`type.currency.${item.currencyId}`)), 1),
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                class: "w-100",
                                type: "number",
                                modelValue: item.initialValue,
                                "onUpdate:modelValue": ($event: any) => ((item.initialValue) = $event),
                                disabled: isSubmitting.value
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                modelValue: item.minValue,
                                "onUpdate:modelValue": ($event: any) => ((item.minValue) = $event),
                                disabled: isSubmitting.value,
                                class: "w-100",
                                type: "number"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_input, {
                                modelValue: item.maxValue,
                                "onUpdate:modelValue": ($event: any) => ((item.maxValue) = $event),
                                disabled: isSubmitting.value,
                                class: "w-100",
                                type: "number"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                            ]),
                            (i == 'Union Pay')
                              ? (_openBlock(), _createElementBlock("td", _hoisted_29, [
                                  _createElementVNode("div", _hoisted_30, [
                                    _createVNode(_component_el_input, {
                                      modelValue: item.percentage,
                                      "onUpdate:modelValue": ($event: any) => ((item.percentage) = $event),
                                      class: "w-100",
                                      type: "number"
                                    }, {
                                      append: _withCtx(() => [
                                        _createTextVNode("%")
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"])
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("td", _hoisted_31)),
                            _createElementVNode("td", null, [
                              (updateHistory.value[item.id])
                                ? (_openBlock(), _createBlock(_component_el_popover, {
                                    key: 0,
                                    width: 350
                                  }, {
                                    reference: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(updateHistory.value[item.id]["userName"]), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$t("fields.updated_at")) + " " + _toDisplayString(updateHistory.value[item.id]["createdOn"]), 1)
                                      ]),
                                      _createElementVNode("div", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(updateHistory.value[item.id][
                        'previous'
                      ], (value, index) => {
                                          return (_openBlock(), _createElementBlock("p", { key: index }, [
                                            value
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(index) + ": " + _toDisplayString(value) + " ⇒ " + _toDisplayString(updateHistory.value[item.id]["current"][index]), 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_button, {
                                type: "warning",
                                onClick: ($event: any) => (singleSubmit(item)),
                                disabled: isSubmitting.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("action.save")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"])
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                onClick: ($event: any) => (showPaymentDetail(item, sortedServices)),
                                disabled: isSubmitting.value
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("action.detail")), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick", "disabled"])
                            ])
                          ]))
                        }), 128))
                      ]))
                    }), 128))
            ])
          ]),
          _createVNode(paymentServiceDetail, {
            ref_key: "paymentDetailRef",
            ref: paymentDetailRef,
            onUpdate: getServices
          }, null, 512),
          _createVNode(paymentServiceCreate, {
            ref_key: "paymentCreateRef",
            ref: paymentCreateRef,
            onEventSubmit: onEventSubmitted
          }, null, 512)
        ]))
  ], 64))
}
}

})